/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  MicrosoftAspNetCoreMvcProblemDetails,
  TrainWithMeModulesTrainingDtosResponsesCalendarFeedResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const deleteMeCalendarFeed = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesCalendarFeedResponse>(
      {url: `/me/calendar-feed`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteMeCalendarFeedMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMeCalendarFeed>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMeCalendarFeed>>, TError,void, TContext> => {

const mutationKey = ['deleteMeCalendarFeed'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMeCalendarFeed>>, void> = () => {


          return  deleteMeCalendarFeed(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMeCalendarFeedMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMeCalendarFeed>>>

    export type DeleteMeCalendarFeedMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const useDeleteMeCalendarFeed = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMeCalendarFeed>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMeCalendarFeed>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteMeCalendarFeedMutationOptions(options), queryClient);
    }
    export const getMeCalendarFeed = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesCalendarFeedResponse>(
      {url: `/me/calendar-feed`, method: 'GET', signal
    },
      options);
    }




export const getGetMeCalendarFeedQueryKey = () => {
    return [
    `/me/calendar-feed`
    ] as const;
    }


export const getGetMeCalendarFeedQueryOptions = <TData = Awaited<ReturnType<typeof getMeCalendarFeed>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeCalendarFeed>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeCalendarFeedQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeCalendarFeed>>> = ({ signal }) => getMeCalendarFeed(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMeCalendarFeed>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeCalendarFeedQueryResult = NonNullable<Awaited<ReturnType<typeof getMeCalendarFeed>>>
export type GetMeCalendarFeedQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetMeCalendarFeed<TData = Awaited<ReturnType<typeof getMeCalendarFeed>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeCalendarFeed>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeCalendarFeed>>,
          TError,
          Awaited<ReturnType<typeof getMeCalendarFeed>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeCalendarFeed<TData = Awaited<ReturnType<typeof getMeCalendarFeed>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeCalendarFeed>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeCalendarFeed>>,
          TError,
          Awaited<ReturnType<typeof getMeCalendarFeed>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeCalendarFeed<TData = Awaited<ReturnType<typeof getMeCalendarFeed>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeCalendarFeed>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMeCalendarFeed<TData = Awaited<ReturnType<typeof getMeCalendarFeed>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeCalendarFeed>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeCalendarFeedQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postMeCalendarFeed = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesCalendarFeedResponse>(
      {url: `/me/calendar-feed`, method: 'POST', signal
    },
      options);
    }




export const getPostMeCalendarFeedMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMeCalendarFeed>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postMeCalendarFeed>>, TError,void, TContext> => {

const mutationKey = ['postMeCalendarFeed'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMeCalendarFeed>>, void> = () => {


          return  postMeCalendarFeed(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostMeCalendarFeedMutationResult = NonNullable<Awaited<ReturnType<typeof postMeCalendarFeed>>>

    export type PostMeCalendarFeedMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostMeCalendarFeed = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMeCalendarFeed>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMeCalendarFeed>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPostMeCalendarFeedMutationOptions(options), queryClient);
    }
    export const postMeCalendarFeedRotate = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesCalendarFeedResponse>(
      {url: `/me/calendar-feed/rotate`, method: 'POST', signal
    },
      options);
    }




export const getPostMeCalendarFeedRotateMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMeCalendarFeedRotate>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postMeCalendarFeedRotate>>, TError,void, TContext> => {

const mutationKey = ['postMeCalendarFeedRotate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMeCalendarFeedRotate>>, void> = () => {


          return  postMeCalendarFeedRotate(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostMeCalendarFeedRotateMutationResult = NonNullable<Awaited<ReturnType<typeof postMeCalendarFeedRotate>>>

    export type PostMeCalendarFeedRotateMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostMeCalendarFeedRotate = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMeCalendarFeedRotate>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMeCalendarFeedRotate>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPostMeCalendarFeedRotateMutationOptions(options), queryClient);
    }
